/**
 * Leaderboard-sheet palette + layout tokens, mirroring the `Warmup Leaderboard.dc.html` design comp.
 * Feature-local shades (the sheet is a slightly deeper purple than the shared Warmup surface) live here
 * so styles never hardcode hex inline.
 */

import { WARMUP_COLORS } from '../../../src/quiz/constants/warmup.constants';

export const GAME_LB_COLORS = {
  sheetBg: '#120D1F',
  sheetBorder: WARMUP_COLORS.border, // #2A2F3A
  handle: '#374151',
  closeBg: WARMUP_COLORS.surfaceAlt, // #1F2937
  closeIcon: WARMUP_COLORS.textDim, // #9CA3AF
  tabSelectedBg: WARMUP_COLORS.purple, // #A78BFA
  tabSelectedText: '#161021',
  tabIdleBg: WARMUP_COLORS.surfaceAlt, // #1F2937
  tabIdleText: WARMUP_COLORS.textDim,
  rowBg: '#1A1426',
  rowMeBg: 'rgba(167,139,250,0.12)',
  rankText: WARMUP_COLORS.textFaint, // #6B7280
  nameText: '#E5E7EB',
  nameMeText: '#C4B5FD',
  /** Score accent — HILO is green; generic enough for the one current game. */
  score: WARMUP_COLORS.green, // #6EE7B7
  crown: WARMUP_COLORS.amber, // #FCD34D
  youBarBg: '#1A1130',
  youInnerBg: 'rgba(167,139,250,0.14)',
  youInnerBorder: 'rgba(167,139,250,0.40)',
  youRank: '#C4B5FD',
  youContext: WARMUP_COLORS.purple,
  // Glowing trophy entry button (header).
  trophyBg: '#161021',
  trophyBorder: '#5A4327',
  trophyGlyph: WARMUP_COLORS.amber,
  trophyGlow: 'rgba(252,211,77,0.55)',
} as const;

/** Podium medal gradient anchors by place (gold / silver / bronze). */
export const PODIUM_MEDAL: Record<1 | 2 | 3, string> = {
  1: WARMUP_COLORS.amber, // #FCD34D
  2: '#D1D5DB',
  3: '#E0A878',
};

/** Pedestal heights (px) by place — 1st tallest. */
export const PODIUM_PEDESTAL_HEIGHT: Record<1 | 2 | 3, number> = { 1: 62, 2: 46, 3: 34 };

/** Podium avatar diameters (px) — 1st larger. */
export const PODIUM_AVATAR_SIZE: Record<1 | 2 | 3, number> = { 1: 60, 2: 50, 3: 50 };

export const GAME_LB_ROW_AVATAR_SIZE = 34;

export const GAME_LB_TEST_IDS = {
  trophy: 'game-lb-trophy',
  sheet: 'game-lb-sheet',
  close: 'game-lb-close',
  tab: (gameKey: string) => `game-lb-tab-${gameKey}`,
  podiumPlace: (rank: number) => `game-lb-podium-${rank}`,
  row: (rank: number) => `game-lb-row-${rank}`,
  youRow: 'game-lb-you',
  loading: 'game-lb-loading',
  empty: 'game-lb-empty',
  error: 'game-lb-error',
  retry: 'game-lb-retry',
} as const;
